export default "__VITE_ASSET__Bsr_XwgQ__"